






























































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { MswAppTitle } from '@/shared/msw-app-title';
import uuifComponent from '@/shared/uuifComponent';
import { InfoState } from '../../../core/core.store';
import { tooltip } from '@libs-uuif/shared/tooltip-dir';
import _ from 'lodash';
const cssPrefix = 'shopping-cart';

@Component({
  components: {
    MswAppTitle,
    ...uuifComponent,
  },
  directives: {
    tooltip,
  },
})
export default class ShoppingCart extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  showPricingChange : boolean = false;
  isRMQuote:boolean = false;
  guestbuynow: boolean = false;
  isHesSku: boolean = false;
  cartDetails: any[] = [];
  totalPrice: string = '';
  totalTax: string = '';
  basketId: string = '';
  emptyBasket: string = '';

  quantityUpdatePendingQuantity: number = 0;
  created() {
    if (localStorage.getItem('showPricingChange')) {
      if (localStorage.getItem('showPricingChange') === 'YES') {
        this.showPricingChange =  true;
      } else {
        this.showPricingChange = false;
      }
    }
    if (localStorage.getItem('RMQUOTE')) {
      if (localStorage.getItem('RMQUOTE') === 'YES') {
        this.isRMQuote = true;
      }
    }
    if (this.$store.getters.getUserId.toUpperCase() === 'GUESTBUYNOW') {
      this.guestbuynow = true;
    }
    this.getBasketDetails();
  }

  getBasketDetails() {
    this.$store.dispatch('CatalogStoreModule/getBasketDetails')
    .then((response : any) => {
      if (response.operationStatus === 'OK') {
        this.isHesSku = response.content.isHesSku ? response.content.isHesSku : false;
        this.cartDetails = response.content.basketItems ? response.content.basketItems : [];
        this.totalPrice = response.content.basketDetails.totalPrice ? response.content.basketDetails.totalPrice : '';
        this.totalTax = response.content.basketDetails.totalTax ? response.content.basketDetails.totalTax : '';
        this.basketId = response.content.basketDetails.basketId ? response.content.basketDetails.basketId : '';
      } else {
        this.cartDetails = [];
        this.emptyBasket = response.msgDesc;
        if (response.msgCode === 'BASKET:EMPTYBASKET') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount',  0);
        }
      }
      this.$store.commit('stopLoading');
    });
  }
  serialClick(serialNumber: any) {
    this.pushToRoute('/m/feature/products', { serialNumber, tab: 'licenses' });
  }
  checkoutCartWrapper() {
    if (this.isHesSku) {
      if (this.cartDetails[0] &&
          this.cartDetails[0].hasOwnProperty('nodeCount') &&
          this.cartDetails[0].hasOwnProperty('basketItemId') &&
          this.cartDetails[0]!.nodeCount >= 10 &&
          this.cartDetails[0]!.nodeCount <= 99999) {
        const request = {
          usercount: this.cartDetails[0]!.hasOwnProperty('nodeCount') ? this.cartDetails[0].nodeCount : 0,
          basketitemid: this.cartDetails[0].hasOwnProperty('basketItemId') ? this.cartDetails[0].basketItemId : '',
        };
        this.$store.dispatch('CatalogStoreModule/updateUserCount', request)
          .then((response: any) => {
            if (response.operationStatus === 'OK') {
              this.$store.commit('stopLoading');
              this.continueCheckout();
            } else {
              const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
              this.$store.commit('displayMessage', message);
            }
          })
          .catch((errResponse: any) => {
            this.$store.commit('stopLoading');
            const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
            this.$store.commit('displayMessage', message);
          });
      } else {
        const message: InfoState = { infoType: 'high', infoMsg: 'User Count must be in range 10 - 99999' };
        this.$store.commit('displayMessage', message);
      }
    } else {
      this.continueCheckout();
    }
  }
  continueCheckout() {
    this.$store.commit('startLoading');
    const looper = setInterval(
      ((self) => {
        return () => {
          if (self.quantityUpdatePendingQuantity === 0) {
            clearInterval(looper);
            this.$store.commit('stopLoading');
            self.checkout();
          }
        };
      })(this),
      100,
    );
  }
  gotoProducts() {
    this.pushToRoute('/m/feature/products');
  }
  checkout() {
    this.replaceRoute('/m/feature/checkout/billing', { basketid: this.basketId });
  }
  autoRenewalChange(isAutoRenew: boolean, basketItemId : any) {
    let requestData: any = {};
    if (isAutoRenew) {
      requestData = {
        renew: 'YES',
        basketitemid: basketItemId,
      };
    } else {
      requestData = {
        renew: 'NO',
        basketitemid: basketItemId,
      };
    }
    this.$store.dispatch('CatalogStoreModule/updateAutoRenewal', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
          this.$store.commit('displayMessage', message);
        } else {
          this.cartDetails.forEach((cartItem: any) => {
            if (cartItem.basketItemId === basketItemId) {
              cartItem.isAutoRenew = !isAutoRenew;
            }
          });
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  pushToRoute(routePath: string, routeQuery: any = {}) {
    const subUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser.toString() : '';
    if ((window as { [key: string]: any }).location.href !== (window as { [key: string]: any }).top.location.href) {
      window.parent.postMessage(
        {
          redirectUrl : this.getRedirectUrl(routePath, routeQuery),
        },
        '*',
      );
    } else {
      if (subUser && subUser !== '') {
        this.$router.push({ path: routePath, query: { ...routeQuery, snbuser: subUser } })
          .catch((routeError: any) => {
            console.warn(routeError);
          });
      } else {
        this.$router.push({ path: routePath, query: { ...routeQuery } })
          .catch((routeError: any) => {
            console.warn(routeError);
          });
      }
    }
  }

  getRedirectUrl(path: string, routeQuery: any = {}) {
    let queryParams: string = '';
    if (!_.isEmpty(routeQuery)) {
      const keys: any[] = Object.keys(routeQuery) || [];
      for (let i = 0; i < keys.length; i = i + 1) {
        const key: string = keys[i] || '';
        const keyValue: string = (key && routeQuery[key]) || '';
        queryParams = `${queryParams}${key}=${keyValue}${i === (keys.length - 1) ? '' : '&'}`;
      }
    }
    return `${path}${queryParams !== '' ? '?' : ''}${queryParams}`;
  }

  replaceRoute(routePath: string, routeQuery: any = {}) {
    const subUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser.toString() : '';
    if ((window as { [key: string]: any }).location.href !== (window as { [key: string]: any }).top.location.href) {
      window.parent.postMessage(
        {
          redirectUrl : this.getRedirectUrl(routePath, routeQuery),
        },
        '*',
      );
    }
    if (subUser && subUser !== '') {
      this.$router.replace({ path: routePath, query: { ...routeQuery, snbuser: subUser } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    } else {
      this.$router.replace({ path: routePath, query: { ...routeQuery } })
        .catch((routeError: any) => {
          console.warn(routeError);
        });
    }
  }
  removeFromCart(basketItemId: any) {
    this.$store.dispatch('CatalogStoreModule/removeFromCart', { basketItemId })
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount', +(response?.content?.cartCount || 0));
          this.getBasketDetails();
          const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.message ? errResponse.message :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }

  nodeCountChange(event: any, id: any) {
    let nodecount = event.target.value;
    let bisvalid: boolean = true;
    this.cartDetails.forEach((cartItem: any) => {
      if (cartItem.basketItemId === id) {
        if (nodecount === '') {
          nodecount = cartItem.minNodeCount;
        }
        const oldval: any = cartItem.nodeCount;
        const inodecount: number = nodecount;
        const imincount: number = cartItem.minNodeCount;
        const imaxcount: number = cartItem.maxNodeCount;
        if (inodecount - imincount < 0) {
          cartItem.nodeCount = oldval;
          event.target.value = oldval;
          nodecount = oldval;
          const message: InfoState = { infoType: 'high', infoMsg: `${'common.minusers'}${cartItem.minNodeCount}` };
          this.$store.commit('displayMessage', message);
          bisvalid = false;
        }
        if (inodecount - imaxcount > 0) {
          cartItem.nodeCount = oldval;
          event.target.value = oldval;
          nodecount = oldval;
          const message: InfoState = { infoType: 'high', infoMsg: `${'common.maxusers'}${cartItem.maxNodeCount}` };
          this.$store.commit('displayMessage', message);
          bisvalid = false;
        }
      }
      if (bisvalid) {
        cartItem.nodeCount = event.target.value;
      }
    });
    const requestData = {
      nodecount,
      basketitemid: id,
    };
    this.$store.dispatch('CatalogStoreModule/updateNodeCount', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.totalPrice = response.content.totalPrice;
          if (bisvalid) {
            const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
            this.$store.commit('displayMessage', message);
          }
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        this.quantityUpdatePendingQuantity = this.quantityUpdatePendingQuantity - 1;
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }

  restrictNodeCount(event:  any) {
    const key = window.event ? event.keyCode : event.which;
    if (event.keyCode === 8 || event.keyCode === 46) {
      return true;
    }
    if (key < 49 || key > 57) {
      return false;
    }
    return true;
  }
  saveQuote() {
    const requestData = {
      basketid: this.basketId,
    };
    this.$store.commit('stopLoading');
    this.$store.dispatch('CatalogStoreModule/saveQuote' , requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
          const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
          this.$store.commit('displayMessage', message);
          this.pushToRoute('/m/feature/quoteDetails', { selectedQuoteId: response.content.quoteId });
        } else {
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.msgDesc ? errResponse.msgDesc :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }
  qtyChange(value: any, id: any) {
    let quantity = value;
    if (quantity < 1 || quantity > 9) {
      const message: InfoState = {
        infoType: 'high',
        infoMsg: this.$t('catalog.quantityError')
          .toString(),
      };
      this.$store.commit('displayMessage', message);
      return;
    }
    if (quantity === '') {
      this.cartDetails.forEach((cartItem: any) => {
        if (cartItem.basketItemId === id) {
          cartItem.noOfItems = '1';
          quantity = '1';
        }
      });
    }
    const requestData = {
      qty: quantity,
      basketitemid: id,
    };
    this.quantityUpdatePendingQuantity = this.quantityUpdatePendingQuantity + 1;
    this.$store.dispatch('CatalogStoreModule/updateQuantityOfItemsInCart', requestData)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.totalPrice = response.content.totalPrice;
          this.quantityUpdatePendingQuantity = this.quantityUpdatePendingQuantity - 1;
          this.$store.dispatch('CatalogStoreModule/changeCartCount', response.content.cartCount || 0);
          const message: InfoState = { infoType: 'success', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is succesful' };
          this.$store.commit('displayMessage', message);
        } else {
          this.quantityUpdatePendingQuantity = this.quantityUpdatePendingQuantity - 1;
          const message: InfoState = { infoType: 'high', infoMsg: response.msgDesc ? response.msgDesc :  'Operation is unsuccesful' };
          this.$store.commit('displayMessage', message);
        }
      })
      .catch((errResponse: any) => {
        this.quantityUpdatePendingQuantity = this.quantityUpdatePendingQuantity - 1;
        this.$store.commit('stopLoading');
        const message: InfoState = { infoType: 'high', infoMsg: errResponse.message ? errResponse.message :  'Operation is unsuccesful' };
        this.$store.commit('displayMessage', message);
      });
  }

  continueShopping() {
    if (this.cartDetails.length === 0) {
      this.pushToRoute('/m/feature/catalog');
    } else {
      this.cartDetails.sort((a: any, b: any) => {
        return b.basketItemId - a.basketItemId;
      });
      if (this.cartDetails[0].seriaNo.length < 12) {
        this.pushToRoute('/m/feature/catalog');
      } else {
        if (this.isRMQuote) {
          this.pushToRoute('/m/feature/catalog');
        } else {
          this.pushToRoute('/m/feature/products', { serialNumber: this.cartDetails[0].seriaNo, tab: 'licenses' });
        }
      }
    }
  }

}
